import { TicketType } from '../models/ticket-type.enum';
import { PublicTransportConstants } from '../constants/public-transport.constants';
import { TranslationService } from '../../../services/translation.service';
import type { ZoneType } from '../models/zone-type.enum';

export default class ResultTextHelper {
  public static getSelectedTicketAndCost(ticketType: TicketType, zones: ZoneType[]): { selectedTicketCost: number; ticketTranslation: string } {
    let selectedTicketCost: number;
    let ticketTranslation: string;
    switch (ticketType) {
      case TicketType.SingleTicket:
        ticketTranslation = TranslationService.get('pricecalculatorpage.tickettype.singleticket');
        switch (zones.length) {
          case 1:
            selectedTicketCost = PublicTransportConstants.singleTicketOneZonePriceInSek;
            break;
          case 2:
            selectedTicketCost = PublicTransportConstants.singleTicketTwoZonesPriceInSek;
            break;
          default:
            selectedTicketCost = PublicTransportConstants.singleTicketThreeZonesPriceInSek;
            break;
        }
        return { selectedTicketCost, ticketTranslation };

      case TicketType.DayTicket:
        ticketTranslation = TranslationService.get('pricecalculatorpage.tickettype.dayticket24hours');
        switch (zones.length) {
          case 1:
            selectedTicketCost = PublicTransportConstants.dayTicketOneZonePriceInSek;
            break;
          case 2:
            selectedTicketCost = PublicTransportConstants.dayTicketTwoZonesPriceInSek;
            break;
          default:
            selectedTicketCost = PublicTransportConstants.dayTicketThreeZonesPriceInSek;
            break;
        }
        return { selectedTicketCost, ticketTranslation };

      case TicketType.ThreeDayTicket:
        ticketTranslation = TranslationService.get('pricecalculatorpage.tickettype.dayticket72hours');
        switch (zones.length) {
          case 1:
            selectedTicketCost = PublicTransportConstants.threeDaysTicketOneZonePriceInSek;
            break;
          case 2:
            selectedTicketCost = PublicTransportConstants.threeDaysTicketTwoZonesPriceInSek;
            break;
          default:
            selectedTicketCost = PublicTransportConstants.threeDaysTicketThreeZonesPriceInSek;
            break;
        }
        return { selectedTicketCost, ticketTranslation };

      case TicketType.ThirtyDays:
        ticketTranslation = TranslationService.get('pricecalculatorpage.tickettype.periodticket30days');
        switch (zones.length) {
          case 1:
            selectedTicketCost = PublicTransportConstants.periodTicket30DaysOneZonePriceInSek;
            break;
          case 2:
            selectedTicketCost = PublicTransportConstants.periodTicket30DaysTwoZonesPriceInSek;
            break;
          default:
            selectedTicketCost = PublicTransportConstants.periodTicket30DaysThreeZonesPriceInSek;
            break;
        }
        return { selectedTicketCost, ticketTranslation };

      case TicketType.NinetyDays:
        ticketTranslation = TranslationService.get('pricecalculatorpage.tickettype.periodticket90days');
        switch (zones.length) {
          case 1:
            selectedTicketCost = PublicTransportConstants.periodTicket90DaysOneZonePriceInSek;
            break;
          case 2:
            selectedTicketCost = PublicTransportConstants.periodTicket90DaysTwoZonesPriceInSek;
            break;
          default:
            selectedTicketCost = PublicTransportConstants.periodTicket90DaysThreeZonesPriceInSek;
            break;
        }
        return { selectedTicketCost, ticketTranslation };

      case TicketType.ThreeHundredSixtyFiveDays:
        ticketTranslation = TranslationService.get('pricecalculatorpage.tickettype.periodticket365days');
        switch (zones.length) {
          case 1:
            selectedTicketCost = PublicTransportConstants.periodTicket365DaysOneZonePriceInSek;
            break;
          case 2:
            selectedTicketCost = PublicTransportConstants.periodTicket365DaysTwoZonesPriceInSek;
            break;
          default:
            selectedTicketCost = PublicTransportConstants.periodTicket365DaysThreeZonesPriceInSek;
            break;
        }
        return { selectedTicketCost, ticketTranslation };

      default:
        return { selectedTicketCost: 0, ticketTranslation: '' };
    }
  }
}
